"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _colorUtils = require("../../utils/colorUtils");
var _getRgbaFromHex = _interopRequireDefault(require("../../utils/getRgbaFromHex"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Modal = {
  styles: function styles(theme) {
    return {
      defaultModalBoxStyles: {
        borderRadius: 4,
        borderImageSlice: 0,
        backgroundColor: theme.colors.themeBase,
        boxShadow: "0 ".concat(theme.spacing.base * 2, "px ").concat(theme.spacing.base * 3, "px 0 ").concat((0, _getRgbaFromHex.default)(theme.colors.baseShadow, 0.14), ", 0 0 ").concat(theme.spacing.base * 3, "px 0 ").concat((0, _getRgbaFromHex.default)(theme.colors.baseShadow, 0.14))
      },
      defaultModalOverlayStyles: {
        backgroundColor: (0, _getRgbaFromHex.default)(theme.colors.themeBase, 0.8)
      },
      defaultCloseButtonStyles: {
        color: theme.colors.primary,
        backgroundColor: theme.colors.themeBase,
        "& svg": {
          fill: theme.colors.primary,
          "&:hover": {
            fill: (0, _colorUtils.getHoverColor)(theme.colors.primary, 130, 15).toHexString()
          }
        }
      }
    };
  }
};
var _default = exports.default = Modal;